import surveysService from './surveysService';

import type { LaunchedSurvey } from '@/types/cycle-evaluation/LaunchedSurvey';

import { CycleEvaluationQueryKey } from '@/constants/QueryKeys';
import { useAmelioPaginatedQuery } from '@/hooks/api/useAmelioPaginatedQuery';

const useGetSurveysPaged = ({
    sentCycleId,
    pageNumber,
    pageSize,
}: {
    sentCycleId: string;
    pageNumber: number;
    pageSize: number;
}) => {
    return useAmelioPaginatedQuery<LaunchedSurvey>({
        queryKey: [CycleEvaluationQueryKey.SURVEYS, sentCycleId],
        queryFn: surveysService.getSurveys,
        pageNumber,
        pageSize,
        meta: { sentCycleId },
        options: {
            enabled: !!sentCycleId,
        },
    });
};

const useExportSurveys = () => {
    return {
        exportSurveys: surveysService.exportSurveys,
    };
};

export { useGetSurveysPaged, useExportSurveys };
